import { MultiValue } from "react-select";
import { RouteAction } from "./action";
import { RouteState, routeState } from "./state";
import { BinInfo } from "../staticInfo/state";
import moment from "moment";

export function RouteReducer(
    state: RouteState = routeState,
    action: RouteAction
): RouteState {
    switch (action.type) {
        case "@@RouteState/initCollectorAction":
            return {
                ...state,
                collectorList: action.collectorList,
            };
        case "@@RouteState/SelectBinInfosAction":
            return {
                ...state,
                selectedBinInfo: action.selectedBinInfo,
            };
        case "@@RouteState/ChangeRouteName":
            return {
                ...state,
                route_name: action.route_name,
            };
        case "@@RouteState/ChangeCollectorAction":
            return {
                ...state,
                collector_id: action.collector_id,
            };
        case "@@RouteState/ChangeWorkingDate":
            return {
                ...state,
                weekday: action.weekday,
            };
        case "@@RouteState/ChangeRouteRemark":
            return {
                ...state,
                remark: action.remark,
            };
        case "@@RouteState/ChangeEffectiveDateAction":
            return {
                ...state,
                effective_day: action.date,
            };
        case "@@RouteState/ClearRouteFormDataAction":
            return {
                ...state,
                route_id:null,
                collectorList: null,
                selectedBinInfo: null,
                route_name: "",
                collector_id: "",
                weekday: "",
                remark: "",
                effective_day: null,
            };
        case "@@RouteState/initRouteListAction":
            return {
                ...state,
                routeList: action.routeList,
            };
        case "@@RouteState/GetDataFromRouteListAction": 
            const effective_dateConvert = moment.utc(action.routeData.effective_day)
            return {
                ...state,
                collector_id: action.routeData.collector_id,
                selectedBinInfo: action.routeList as MultiValue<BinInfo>,
                route_name: action.routeData.route_name,
                weekday: action.routeData.weekday,
                remark: action.routeData.remark ? action.routeData.remark : "",
                effective_day:effective_dateConvert,
                route_id: action.routeData.route_id
                    ? action.routeData.route_id
                    : null,
            };

        case "@@RouteState/initCollectRouteListAction":
            return {
                ...state,
                RouteCollectionList: action.RouteCollectionList,
            };

        case "@@RouteState/ChangeRouteTimeStartTimeAction":
            const target_bin = state.selectedBinInfo![action.index];
            if (target_bin) {
                const updatedBin = {
                    ...target_bin,
                    time_start: action.start_time,
                };

                const updatedSelectedBinInfo = state.selectedBinInfo?.map(
                    (bin, index) => (index === action.index ? updatedBin : bin)
                );
                return {
                    ...state,
                    selectedBinInfo: updatedSelectedBinInfo!,
                };
            }
            return state;

        case '@@RouteState/ChangeRouteTimeEndTimeAction':
            const _target_bin = state.selectedBinInfo![action.index];
            if (_target_bin) {
                const updatedBin = {
                    ..._target_bin,
                    time_end: action.end_time,
                };

                const updatedSelectedBinInfo = state.selectedBinInfo?.map(
                    (bin, index) => (index === action.index ? updatedBin : bin)
                );
                return {
                    ...state,
                    selectedBinInfo: updatedSelectedBinInfo!,
                };
            }
            return state;

        default:
            return state;
    }
}
